import { PSMS_MCR_INVENTORY_FAILURE, PSMS_MCR_INVENTORY_LOADING, PSMS_MCR_INVENTORY_REQUEST, PSMS_MCR_INVENTORY_SUCCESS, PSMS_MCR_EVALUATION_DETAILS_REQUEST, PSMS_MCR_EVALUATION_DETAILS_LOADING, PSMS_MCR_EVALUATION_DETAILS_SUCCESS, PSMS_MCR_EVALUATION_DETAILS_FAILURE, PSMS_CLAIMS_SUMMARY_REQUEST, PSMS_CLAIMS_SUMMARY_SUCCESS, PSMS_CLAIMS_SUMMARY_FAILURE, PSMS_CLAIMS_SUMMARY_LOADING, PSMSCLAIMS_APPEALS_TREND_DATA_FAILURE, PSMSCLAIMS_APPEALS_TREND_DATA_LOADING, PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST, PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS, PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING, PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST, PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS, PSMSCLAIMS_RECON_DATA_LOADING, PSMSCLAIMS_RECON_DATA_REQUEST, PSMSCLAIMS_RECON_DATA_SUCCESS, PSMSCLAIMS_TOPREASONS_DATA_LOADING, PSMSCLAIMS_TOPREASONS_DATA_REQUEST, PSMSCLAIMS_TOPREASONS_DATA_SUCCESS, PSMSCLAIMS_TOPREASONS_DATA_FAILURE, PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS, PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST } from "../actionTypes";

import { PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST, PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING, PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS, PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR } from '../actionTypes';

import {
    PSMSCLAIMS_OUTCOME_REASONS_REQUEST,
    PSMSCLAIMS_OUTCOME_REASONS_SUCCESS,
    PSMSCLAIMS_OUTCOME_REASONS_FAILURE,
    PSMSCLAIMS_OUTCOME_REASONS_LOADING,
    PSMSCLAIMS_SUBMISSION_REASONS_REQUEST,
    PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS,
    PSMSCLAIMS_SUBMISSION_REASONS_FAILURE,
    PSMSCLAIMS_SUBMISSION_REASONS_LOADING,
    PSMSCLAIMS_RECON_DETAILS_REQUEST,
    PSMSCLAIMS_RECON_DETAILS_SUCCESS,
    PSMSCLAIMS_RECON_DETAILS_FAILURE,
    PSMSCLAIMS_RECON_DETAILS_LOADING,
} from '../actionTypes';

export const fetchClaimsTrendData = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_TREND_DATA_REQUEST,
    payload
});

export const fetchClaimsTrendDataSuccess = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_TREND_DATA_SUCCESS,
    payload
});

export const fetchClaimsTrendDataLoading = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_TREND_DATA_LOADING,
    payload
});

export const fetchClaimsTrendDataError = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_TREND_DATA_FAILURE,
    payload
});

export const fetchPSMSAppealTrendDataRequest = (payload: any) => ({
    type: PSMSCLAIMS_APPEALS_TREND_DATA_REQUEST,
    payload
});

export const fetchPSMSAppealTrendDataSuccess = (payload: any) => ({
    type: PSMSCLAIMS_APPEALS_TREND_DATA_SUCCESS,
    payload
});

export const fetchPSMSAppealTrendDataLoading = (payload: any) => ({
    type: PSMSCLAIMS_APPEALS_TREND_DATA_LOADING,
    payload
});

export const fetchPSMSAppealTrendDataError = (payload: any) => ({
    type: PSMSCLAIMS_APPEALS_TREND_DATA_FAILURE,
    payload
});

export const fetchTopReasonsData = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_DATA_REQUEST,
    payload
});

export const fetchTopReasonsDataSuccess = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_DATA_SUCCESS,
    payload
});

export const fetchTopReasonsDataLoading = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_DATA_LOADING,
    payload
});

export const fetchTopReasonsDataError = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_DATA_FAILURE,
    payload
});

export const fetchTopReasonsHeaderData = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_REQUEST,
    payload
});

export const fetchTopReasonsHeaderDataLoading = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_LOADING,
    payload
});

export const fetchTopReasonsHeaderDataSuccess = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_SUCCESS,
    payload
});

export const fetchTopReasonsHeaderDataError = (payload: any) => ({
    type: PSMSCLAIMS_TOPREASONS_HEADER_DATA_ERROR,
    payload
});

export const fetchClaimsReconData = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DATA_REQUEST,
    payload
});

export const fetchClaimsReconDataLoading = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DATA_LOADING,
    payload
});

export const fetchClaimsReconDataSuccess = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DATA_SUCCESS,
    payload
});

// Outcome Volume actions
export const fetchPsmsOutcomeReasons = (payload: any) => ({
    type: PSMSCLAIMS_OUTCOME_REASONS_REQUEST,
    payload,
});
export const fetchPsmsOutcomeReasonsSuccess = (payload: any) => ({
    type: PSMSCLAIMS_OUTCOME_REASONS_SUCCESS,
    payload,
});
export const fetchPsmsOutcomeReasonsFailure = (payload: any) => ({
    type: PSMSCLAIMS_OUTCOME_REASONS_FAILURE,
    payload,
});
export const fetchPsmsOutcomeReasonsLoading = (payload: boolean) => ({
    type: PSMSCLAIMS_OUTCOME_REASONS_LOADING,
    payload,
});

export const fetchPsmsSubmissionReasons = (payload: any) => ({
    type: PSMSCLAIMS_SUBMISSION_REASONS_REQUEST,
    payload,
});
export const fetchPsmsSubmissionReasonsSuccess = (payload: any) => ({
    type: PSMSCLAIMS_SUBMISSION_REASONS_SUCCESS,
    payload,
});
export const fetchPsmsSubmissionReasonsFailure = (payload: any) => ({
    type: PSMSCLAIMS_SUBMISSION_REASONS_FAILURE,
    payload,
});
export const fetchPsmsSubmissionReasonsLoading = (payload: boolean) => ({
    type: PSMSCLAIMS_SUBMISSION_REASONS_LOADING,
    payload,
});

export const fetchPsmsReconDetails = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DETAILS_REQUEST,
    payload,
});
export const fetchPsmsReconDetailsSuccess = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DETAILS_SUCCESS,
    payload,
});
export const fetchPsmsReconDetailsFailure = (payload: any) => ({
    type: PSMSCLAIMS_RECON_DETAILS_FAILURE,
    payload,
});
export const fetchPsmsReconDetailsLoading = (payload: boolean) => ({
    type: PSMSCLAIMS_RECON_DETAILS_LOADING,
    payload,
});

/**
 * MCR Inventory Actions
 */
export const fetchMcrInventoryRequest = (payload: any) => ({
    type: PSMS_MCR_INVENTORY_REQUEST,
    payload,
});

export const fetchMcrInventoryLoading = (loading: boolean) => ({
    type: PSMS_MCR_INVENTORY_LOADING,
    payload: loading,
});

export const fetchMcrInventorySuccess = (payload: any) => ({
    type: PSMS_MCR_INVENTORY_SUCCESS,
    payload,
});

export const fetchMcrInventoryFailure = (error: string) => ({
    type: PSMS_MCR_INVENTORY_FAILURE,
    payload: error,
});

/**
 * Claims Summary Actions
 */
export const fetchClaimsSummaryRequest = (payload: any) => ({
    type: PSMS_CLAIMS_SUMMARY_REQUEST,
    payload,
});

export const fetchClaimsSummaryLoading = (loading: boolean) => ({
    type: PSMS_CLAIMS_SUMMARY_LOADING,
    payload: loading,
});

export const fetchClaimsSummarySuccess = (payload: any) => ({
    type: PSMS_CLAIMS_SUMMARY_SUCCESS,
    payload,
});

export const fetchClaimsSummaryFailure = (error: string) => ({
    type: PSMS_CLAIMS_SUMMARY_FAILURE,
    payload: error,
});

/**
 * MCR Evaluation Details Actions
 */
export const fetchMcrEvaluationDetailsRequest = (payload: any) => ({
    type: PSMS_MCR_EVALUATION_DETAILS_REQUEST,
    payload,
});

export const fetchMcrEvaluationDetailsLoading = (loading: boolean) => ({
    type: PSMS_MCR_EVALUATION_DETAILS_LOADING,
    payload: loading,
});

export const fetchMcrEvaluationDetailsSuccess = (payload: any) => ({
    type: PSMS_MCR_EVALUATION_DETAILS_SUCCESS,
    payload,
});

export const fetchMcrEvaluationDetailsFailure = (error: string) => ({
    type: PSMS_MCR_EVALUATION_DETAILS_FAILURE,
    payload: error,
});

export const fetchClaimsAppealsSubmission = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_REQUEST,
    payload,
});
export const fetchClaimsAppealsSubmissionSuccess = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_SUCCESS,
    payload,
});
export const fetchClaimsAppealsSubmissionFailure = (payload: any) => ({
    type: PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_FAILURE,
    payload,
});
export const fetchClaimsAppealsSubmissionLoading = (payload: boolean) => ({
    type: PSMSCLAIMS_CLAIMS_APPEALS_SUBMISSION_LOADING,
    payload,
});